import { designTokens } from './tokens';

/** 표면만 공유합니다. role, 초점, 위치 계산과 내용의 padding은 각 합성이 소유합니다. */
export function popupSurfaceStyles(role: 'menu' | 'dialog') {
  return {
    border: `1px solid ${designTokens.color.divider}`,
    borderRadius: role === 'menu' ? designTokens.radius.popover : designTokens.radius.dialog,
    boxShadow: role === 'menu' ? designTokens.shadow.menu : designTokens.shadow.anchoredDialog,
    backgroundColor: designTokens.color.canvas,
    backgroundImage: 'none',
  };
}
